// Тексты каркаса витрины, которые показываются ещё до того, как пришли редактируемые
// тексты продавца (Shop.texts) — собраны в одном месте, как messages.go на бэкенде
// (docs/09-code-standards.md §4).
export const messages = {
  loading: "Загружаем магазин…",
  network: "Нет соединения",
  retry: "Повторить",
  shopUnavailable: "Магазин временно недоступен",
  shopUnavailableHint: "Продавец временно приостановил магазин. Попробуйте открыть его позже.",
  invalidLink: "Ссылка на магазин недействительна",
  invalidLinkHint: "Откройте магазин заново по ссылке из Telegram.",
  openInTelegram: "Откройте магазин через Telegram",
  openInTelegramHint: "Эта страница работает только внутри Telegram Mini App.",
  requestFailed: "Не удалось загрузить магазин",
  searchPlaceholder: "Поиск",
  allCategories: "Все",
  outOfStock: "Нет в наличии",
  emptyCatalogTitle: "Магазин пока наполняется",
  writeToManager: "Написать менеджеру",
  showAllProducts: "Показать все товары",
  productNotFound: "Товар не найден",
  addToCart: "Добавить в корзину",
  goToCart: "Перейти в корзину",
  cartLabel: "Корзина",
  emptyCart: "Корзина пуста",
  backToCatalog: "Вернуться в каталог",
  removeItem: "Убрать",
  itemsTotal: "Товары",
  delivery: "Доставка",
  deliveryCalculatedAtCheckout: "рассчитывается при оформлении",
  deliveryFree: "Бесплатно",
  total: "К оплате",
  checkout: "Оформить заказ",

  // Оформление заказа (docs/07-miniapp-ux.md §2.5).
  fulfillmentDelivery: "Доставка",
  fulfillmentPickup: "Самовывоз",
  pickupPointLabel: "Пункт самовывоза",
  addressLabel: "Адрес",
  addressPlaceholder: "Улица, дом, квартира",
  nameLabel: "Имя",
  phoneLabel: "Телефон",
  takeFromTelegram: "Взять из Telegram",
  // Техническая неудача запроса номера: покупателю нужно сказать, что делать
  // дальше, иначе кнопка выглядит сломанной (docs/09-code-standards.md §8).
  takeFromTelegramFailed: "Не удалось получить номер из Telegram — введите вручную",
  paymentMethodLabel: "Способ оплаты",
  commentLabel: "Комментарий",
  commentPlaceholder: "Позвонить за час, домофон и т.д.",
  submitOrder: "Оформить заказ",
  // 152-ФЗ: согласие должно быть конкретным. Передача данных продавцу названа
  // прямо — оператором выступает платформа, продавец получает данные как третье
  // лицо, и без упоминания передачи согласие её бы не покрывало.
  consentLabel: "Согласен на обработку моих данных и на их передачу продавцу для исполнения заказа —",
  consentPolicyLink: "политика обработки данных",
  orderSubmitFailed: "Не удалось оформить заказ",

  // Мои заказы (docs/07-miniapp-ux.md §2.7).
  myOrdersTitle: "Мои заказы",
  // В шапке каталога подпись короче: рядом стоит название магазина.
  ordersLink: "Заказы",
  myOrdersEmpty: "Пока нет ни одного заказа",
  orderNumberLabel: "Заказ №",
  orderNotFound: "Заказ не найден",
} as const;

/** searchNotFound — текст пустого результата поиска с подставленным запросом. */
export function searchNotFound(query: string): string {
  return `Ничего не найдено по запросу «${query}»`;
}

/**
 * minOrderHint — подпись MainButton, пока сумма корзины не достигла минимальной
 * (docs/07-miniapp-ux.md §2.4). Точную недостающую сумму не считаем на фронте
 * (docs/09-code-standards.md §8: цены — с бэкенда): показываем порог целиком.
 */
export function minOrderHint(minOrderTotalText: string): string {
  return `Минимальный заказ — ${minOrderTotalText}`;
}

/** orderAcceptedTitle — заголовок экрана успеха (docs/07-miniapp-ux.md §2.6). */
export function orderAcceptedTitle(number: number): string {
  return `Заказ №${number} принят!`;
}

/** contactByPhoneHint — подпись под номером телефона на экране успеха. */
export function contactByPhoneHint(maskedPhone: string): string {
  return `Мы свяжемся с вами по номеру ${maskedPhone}`;
}
